import { Mutation, Query } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { HttpStatusCode } from "constants/enums";
import { toastServerError } from "helpers";
import { useAuthTokens } from "modules/auth";

export const useQueryErrorHandler = () => {
  const { removeTokens } = useAuthTokens();

  return (error: unknown, query: Query | Mutation) => {
    if (isAxiosError(error) && error.response != null) {
      const { status, data } = error.response;

      if (
        (status === HttpStatusCode.BAD_REQUEST ||
          status === HttpStatusCode.UNPROCESSABLE_CONTENT ||
          status === HttpStatusCode.CONFLICT ||
          status === HttpStatusCode.FORBIDDEN) &&
        !query.meta?.preventDefaultBadRequest
      ) {
        toastServerError(error);
      }

      if (
        status === HttpStatusCode.UNAUTHORIZED &&
        !query.meta?.preventDefaultUnauthorized
      ) {
        return removeTokens();
      }

      // preventDefaultNotFound: the caller treats a 404 as "this route is not
      // deployed yet" and hides its feature instead (AI lessons).
      if (
        (status === HttpStatusCode.NOT_FOUND &&
          !query.meta?.preventDefaultNotFound) ||
        status >= HttpStatusCode.INTERNAL_SERVER_ERROR
      ) {
        return alert(`Something went wrong: ${data.error ?? error.message}`);
      }
    }

    return error;
  };
};
